import { Controller } from "@hotwired/stimulus"

const SLIDE_UP_MS = 300

// Auto-dismisses a server-rendered flash alert after `timeout` ms.
export default class extends Controller {
  static values = { timeout: Number }

  connect() {
    if (!this.hasTimeoutValue) return

    this.timer = setTimeout(() => {
      window.$(this.element).slideUp({
        duration: SLIDE_UP_MS,
        done: () => {
          this.element.remove()
        }
      })
    }, this.timeoutValue)
  }

  disconnect() {
    clearTimeout(this.timer)
  }
}
